module.exports = __webpack_public_path__ + "front/img/s2.a8bd90fb.png";